import { RESET_STATE, SET_AUTOPARKS_TRANSPORTS, SET_IS_AUTOPARKS_TRANSPORTS_LOADING, SET_PAGINATION } from './actions';

export const initialState = {
	autoparksTransports: [],
	pagination: null,
	isAutoparksTransportsLoading: false,
};

const autoparksTransportsReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_AUTOPARKS_TRANSPORTS:
			return {
				...state,
				autoparksTransports: payload,
			};
		case SET_IS_AUTOPARKS_TRANSPORTS_LOADING:
			return {
				...state,
				isAutoparksTransportsLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default autoparksTransportsReducer;
